<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu></user-menu>
      <dev-menu v-if="CurrentUserX.role === 'dev'"></dev-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <loading-main-panel v-if="LoadingX"></loading-main-panel>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>

  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import DevMenu from "@/components/UIComponents/SidebarPlugin/DevMenu.vue";
  import LoadingMainPanel from "@/components/Dashboard/Layout/LoadingMainPanel.vue";

  export default {
    components: {
      LoadingMainPanel,
      DevMenu,
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
